import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ITrangThaiHocSinhActionTypes } from "../../action-types/trang-thai-hoc-sinh/ITrangThaiHocSinhActionTypes";
import { ITrangThaiHocSinhReducer } from "../../page-state-model/trang-thai-hoc-sinh/ITrangThaiHocSinhReducer";

const initialState: ITrangThaiHocSinhReducer = {
  status: ePageBaseStatus.is_not_initialization,
  trangThaiHocSinhCoSoItemResponses: [],
  trangThaiHocSinhs: [],
  trangThaiHocSinhVms: [],
  isShowEditModal: false,
};

export const TRANG_THAI_HOC_SINHReducer = (
  state: ITrangThaiHocSinhReducer = initialState,
  action: ITrangThaiHocSinhActionTypes
): ITrangThaiHocSinhReducer => {
  switch (action.type) {
    
    case "TRANG_THAI_HOC_SINH_LOAD_CHECKDANGKY_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_CHECKDANGKY_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhCoSoItemResponses: action.payload,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_CHECKDANGKY_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhCoSoItemResponses: [],
      };
    case "TRANG_THAI_HOC_SINH_LOAD_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhs: action.payload,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhs: [],
      };
    case "TRANG_THAI_HOC_SINH_LOAD_COSO_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_COSO_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhs: action.payload,
      };
    case "TRANG_THAI_HOC_SINH_LOAD_COSO_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiHocSinhs: [],
      };
    case "TRANG_THAI_HOC_SINH_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        editingData: action.payload,
      };
    case "TRANG_THAI_HOC_SINH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "TRANG_THAI_HOC_SINH_SAVE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "TRANG_THAI_HOC_SINH_SAVE_SUCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
        isShowEditModal: false,
      };
    case "TRANG_THAI_HOC_SINH_SAVE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "TRANG_THAI_HOC_SINH_DELETE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_deleting,
      };
    case "TRANG_THAI_HOC_SINH_DELETE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
      };
    case "TRANG_THAI_HOC_SINH_DELETE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_THU_TU_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_THU_TU_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
      };
    case "TRANG_THAI_HOC_SINH_UPDATE_THU_TU_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    default:
      return state;
  }
};